export default __webpack_public_path__ + "static/media/kitchen5-afterC-1920w.f2f7e435.webp";